/**
 * Public browser configuration for Overland's production Supabase project.
 *
 * These values are intentionally bundled into the client. The publishable key
 * uses the anon database role and is protected by Row Level Security; never put
 * a service_role or secret key here.
 */
export const SUPABASE_URL = 'https://sfhynjdpedrkgnbchvge.supabase.co';
export const SUPABASE_ANON_KEY = 'sb_publishable_25EgjpjsY_seRNuUqLSd9A_PpznZywT';
